import { defineComponent as _defineComponent } from 'vue'
import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import type { CourseBundleTestimonial } from '@/services/interfaces/Course'
  import useBreakpoint from '@/composables/useBreakpoint'
  import AutoSlider from '@/components/common/AutoSlider.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseBundleTestimonials',
  props: {
    testimonials: null
  },
  setup(__props: any) {

  

  const { isMobileDevice } = useBreakpoint()

return { __sfc: true,isMobileDevice, HTMLRenderer, useBreakpoint, AutoSlider }
}

})